import { useState, Key, useEffect } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { IPurchasePoFields, IDetailList } from './vrmBillPurchasePoType';
import { purchasePoService } from './vrmBillPurchasePoService';
import { useVrmSaleRoDetailModel } from '../vrmBillSaleRo/vrmBillSaleRoModel';
import { getRawSourceValueGetter } from 'echarts/lib/data/helper/dataProvider';
import useGlobalModel from '@/model/globalModel';

export type IVrmPlanDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	[key: string]: any;
};
export const useVrmPurchasePoDetailsModel = createModel(function () {
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
	};
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const { getVrmTreeNodeName } = useVrmSaleRoDetailModel();
	const {userBranch} = useGlobalModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<IPurchasePoFields>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<IVrmPlanDescType>(initDesc);

	useEffect(() => {
		let newDesc: IVrmPlanDescType = { ...initDesc };
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.num) * Number(item.price);
			});
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList]);

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await purchasePoService.one(id,userBranch);
		if (retData) {
			const { details, ...from } = retData;
			setDetailLookForm({
				...from,
				purchaseTypeName: getVrmTreeNodeName(from.purchaseTypeCode as string),
				supplierTypeName: getVrmTreeNodeName(from.supplierTypeCode as string),
				materialTypeName: getVrmTreeNodeName(from.materialTypeCode as string),
				payType: getVrmTreeNodeName(from.payType as string),
				payMethodName: getVrmTreeNodeName(from.payMethodCode as string),
				invoiceTypeName: getVrmTreeNodeName(from.invoiceTypeCode as string),
				deliveryMethodName: getVrmTreeNodeName(from.deliveryMethod as string),
			});
			setDetailLookList((details as IDetailList[]) ?? []);
		}
	};

	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailLookList([]);
	};

	return {
		initPgCfg,
		detailLookForm,
		detailLookList,
		lookDesc,
		// model
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
